import { privileges } from 'domains/base/_base-enum';

export const designer = [
  privileges.CAMPAIGNS,
  privileges.CAMPAIGN_DUPLICATE,
  privileges.CAMPAIGN_AD_FACTORY,
  privileges.ACADEMY,
];

export const teamMember = [
  privileges.DASHBOARD,
  privileges.CAMPAIGNS,
  privileges.STORES,
  privileges.ACADEMY,

  privileges.DASHBOARD_VISITORS,
  privileges.DASHBOARD_VISITORS_CHART,
  privileges.DASHBOARD_VISITORS_DATA,
  privileges.DASHBOARD_REGIONAL_CHART,
  privileges.DASHBOARD_DEVICES_CHART,
  privileges.DASHBOARD_REFERRALS_CHART,
  privileges.DASHBOARD_MOST_VISITED_CHART,
  privileges.DASHBOARD_MOST_VISITED_DATA,
  privileges.DASHBOARD_HEATMAP,

  privileges.CAMPAIGNS_CSV,

  privileges.CAMPAIGN_DASHBOARD,
  privileges.CAMPAIGN_DETAILS,
  privileges.CAMPAIGN_PROMOTIONS,
  privileges.CAMPAIGN_MARKETING,
  privileges.CAMPAIGN_ASSETS,
  privileges.CAMPAIGN_AD_FACTORY,

  privileges.CAMPAIGN_DUPLICATE,
  privileges.CAMPAIGN_STAR,
  privileges.CAMPAIGN_EXTEND,
  privileges.CAMPAIGN_END,
  privileges.CAMPAIGN_RELAUNCH,
  privileges.CAMPAIGN_EMAIL_REP,
];

export const admin = [
  privileges.DASHBOARD,
  privileges.CAMPAIGNS,
  privileges.ORDERS,
  privileges.PROMOTIONS,
  privileges.STORES,
  privileges.ACADEMY,
  privileges.SETTINGS,

  privileges.DASHBOARD_EARNINGS,
  privileges.DASHBOARD_ORDERS,
  privileges.DASHBOARD_VISITORS,
  privileges.DASHBOARD_CONVERSION,
  privileges.DASHBOARD_VISITORS_CHART,
  privileges.DASHBOARD_VISITORS_DATA,
  privileges.DASHBOARD_REGIONAL_CHART,
  privileges.DASHBOARD_REGIONAL_DATA,
  privileges.DASHBOARD_DEVICES_CHART,
  privileges.DASHBOARD_DEVICES_DATA,
  privileges.DASHBOARD_REFERRALS_CHART,
  privileges.DASHBOARD_REFERRALS_DATA,
  privileges.DASHBOARD_MOST_VISITED_CHART,
  privileges.DASHBOARD_MOST_VISITED_DATA,
  privileges.DASHBOARD_HEATMAP,
  privileges.DASHBOARD_UPSELL_PERFORMANCE,
  privileges.DASHBOARD_PRODUCTS,

  privileges.CAMPAIGNS_CSV,

  privileges.CAMPAIGN_RELAUNCH_DASHBOARD,
  privileges.CAMPAIGN_DASHBOARD,
  privileges.CAMPAIGN_ORDERS,
  privileges.CAMPAIGN_DETAILS,
  privileges.CAMPAIGN_PROMOTIONS,
  privileges.CAMPAIGN_MARKETING,
  privileges.CAMPAIGN_ASSETS,
  privileges.CAMPAIGN_AD_FACTORY,

  privileges.CAMPAIGN_DUPLICATE,
  privileges.CAMPAIGN_STAR,
  privileges.CAMPAIGN_EXTEND,
  privileges.CAMPAIGN_END,
  privileges.CAMPAIGN_RELAUNCH,
  privileges.CAMPAIGN_EMAIL_REP,

  privileges.SETTINGS_NAV,
  privileges.SETTINGS_ACCOUNT_NOTIFICATIONS,
  privileges.SETTINGS_USERS,
  privileges.SETTINGS_USERS_TEAM_MEMBER,
  privileges.SETTINGS_USERS_DESIGNER,
  privileges.SETTINGS_TRACKING,

  privileges.WHITELABEL,
];

export const root = [
  privileges.DASHBOARD,
  privileges.CAMPAIGNS,
  privileges.ORDERS,
  privileges.PROMOTIONS,
  privileges.STORES,
  privileges.ACADEMY,
  privileges.SETTINGS,

  privileges.DASHBOARD_EARNINGS,
  privileges.DASHBOARD_ORDERS,
  privileges.DASHBOARD_VISITORS,
  privileges.DASHBOARD_CONVERSION,
  privileges.DASHBOARD_VISITORS_CHART,
  privileges.DASHBOARD_VISITORS_DATA,
  privileges.DASHBOARD_REGIONAL_CHART,
  privileges.DASHBOARD_REGIONAL_DATA,
  privileges.DASHBOARD_DEVICES_CHART,
  privileges.DASHBOARD_DEVICES_DATA,
  privileges.DASHBOARD_REFERRALS_CHART,
  privileges.DASHBOARD_REFERRALS_DATA,
  privileges.DASHBOARD_MOST_VISITED_CHART,
  privileges.DASHBOARD_MOST_VISITED_DATA,
  privileges.DASHBOARD_HEATMAP,
  privileges.DASHBOARD_UPSELL_PERFORMANCE,
  privileges.DASHBOARD_PRODUCTS,

  privileges.CAMPAIGNS_CSV,

  privileges.CAMPAIGN_RELAUNCH_DASHBOARD,
  privileges.CAMPAIGN_DASHBOARD,
  privileges.CAMPAIGN_ORDERS,
  privileges.CAMPAIGN_DETAILS,
  privileges.CAMPAIGN_PROMOTIONS,
  privileges.CAMPAIGN_MARKETING,
  privileges.CAMPAIGN_ASSETS,
  privileges.CAMPAIGN_AD_FACTORY,

  privileges.CAMPAIGN_DUPLICATE,
  privileges.CAMPAIGN_STAR,
  privileges.CAMPAIGN_EXTEND,
  privileges.CAMPAIGN_END,
  privileges.CAMPAIGN_RELAUNCH,
  privileges.CAMPAIGN_EMAIL_REP,

  privileges.SETTINGS_NAV,
  privileges.SETTINGS_ACCOUNT,
  privileges.SETTINGS_ACCOUNT_NOTIFICATIONS,
  privileges.SETTINGS_CHANGE_PASSWORD,
  privileges.SETTINGS_USERS,
  privileges.SETTINGS_USERS_ADMIN,
  privileges.SETTINGS_USERS_TEAM_MEMBER,
  privileges.SETTINGS_USERS_DESIGNER,
  privileges.SETTINGS_TRACKING,
  privileges.SETTINGS_PAYMENT,
  privileges.SETTINGS_REFERRALS,
  privileges.SETTINGS_EMAILS,
  privileges.SETTINGS_AFFILIATE,

  privileges.WHITELABEL,
];